
<i18n src="@/locales/models/producer.yml" lang="yaml"></i18n>
<template>
  <div class="mt-8 flex flex-col">
    <div class="table-first-container">
      <div class="table-second-container">
        <div class="table-third-container">
          <table class="table">
            <thead class="table-header">
              <tr>
                <th scope="col" class="table-header-cell">
                  {{ $t("model.producer.name") }}
                </th>
                <th scope="col" class="table-header-cell"></th>
              </tr>
            </thead>
            <tbody class="table-body">
              <tr
                class="table-row"
                v-for="(provider, index) in providers"
                :key="index"
              >
                <td
                  class="table-cell link"
                  @click.prevent="goToShowProvider(provider)"
                >
                  {{ provider.name }}
                </td>
                <td class="table-cell-action"></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AELiquidationsQueryProvidersShowProcessDetails",
  data() {
    return {};
  },
  props: {
    agro_exporter_id: { required: true },
    agro_exporter_process_id: { required: true },
    providers: {
      type: Array,
      required: true
    }
  },
  created() {},
  methods: {
    goToShowProvider: function (provider) {
      this.$router.push({
        name: this.routeName("show_provider"),
        params: {
          agro_exporter_id: this.agro_exporter_id,
          agro_exporter_process_id: this.agro_exporter_process_id,
          provider_id: provider.id,
          provider_type: provider.type
        }
      });
    }
  }
};
</script>
